module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western1",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('p', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("The Journal"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nBook Five"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  })]), _c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Fault Line"), _c('br', {
    staticClass: "calibre2"
  })]), _c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Deborah D. Moore")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a72acf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue
// module id = 63
// module chunks = 0